import { render, staticRenderFns } from "./answer-item.vue?vue&type=template&id=07622752&scoped=true&"
import script from "./answer-item.vue?vue&type=script&lang=js&"
export * from "./answer-item.vue?vue&type=script&lang=js&"
import style0 from "./answer-item.vue?vue&type=style&index=0&id=07622752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07622752",
  null
  
)

export default component.exports